/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

// src/utils/zebraPrinter.ts

import ZebraBrowserPrintWrapper from "zebra-browser-print-wrapper";
import { triggerToast } from "../widgets/toaster/toastManager";

export const printWithZebraPrinter = async (zplArray: string[]) => {
    console.log(zplArray, "zplArray")
  try {
    const browserPrint = new ZebraBrowserPrintWrapper();

    const defaultPrinter = await browserPrint.getDefaultPrinter();
    console.log("printWithZebraPrinter => defaultPrinter", defaultPrinter);

    browserPrint.setPrinter(defaultPrinter);

    const printerStatus = await browserPrint.checkPrinterStatus();
    console.log("printWithZebraPrinter => printerStatus", printerStatus);

    if (printerStatus.isReadyToPrint) {
      for (const zpl of zplArray) {
        console.log("printWithZebraPrinter => zpl--", zpl);
        await browserPrint.print(zpl);
      }
    } else {
      console.error("printWithZebraPrinter => printerStatus => Error/s", printerStatus.errors);
      triggerToast("Failed to write to device: Unable to establish connection to 19j164100111", "error");
    }
  } catch (error) {
    console.error("printWithZebraPrinter => catch => Error/s", error);
    let message = "An unexpected error occurred";
    if (error instanceof Error) {
      message = error.message;
    }
    triggerToast("Failed to write to device: Unable to establish connection to 19j164100111", "error");
  }
};
